export default "__VITE_ASSET__BAEAb9Lg__"